import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Slider from "react-slick";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import ContentHeading from "../../../shared/commonComponents/ContentHeading";
import PostComment from "../../discussionBoard/postComment";
import Comment from "../../discussionBoard/comment";

import { NetworkAxios } from "../../../API";
import authSlice from "../../../store/auth/authSlice";
import Avatar from "../../../shared/commonComponents/Avatar";
import ShowMore from "../../../shared/commonComponents/ShowMore";

const Solve = (props) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.loggedInUser.userId);
  const offeringUserId = useSelector(
    (state) => state.auth.loggedInUser.offeringUserId
  );
  const teamForumId = useSelector(
    (state) => state.auth.loggedInUser.teamForumId
  );
  const teamId = useSelector((state) => state.auth.loggedInUser.teamId);
  const currentStage = useSelector((state) => state.appState.currentStage);
  const [showAssignment, setShowAssignment] = useState(false);

  const stageActivities = useSelector(
    (state) => state.journeyMapSlice.stageActivities
  );

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 3,
        },
      },
      {
        breakpoint: 1720,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 5,
        },
      },
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 4,
        },
      },
    ],
  };

  const [assignmentList, setAssignmentList] = useState([]);

  const [comments, setcomments] = useState([]);
  const [localCommentList, setLocalCommentList] = useState(comments);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);
  const [thread, setThread] = useState(null);

  const searchComments = (item) => {
    setIsFiltered(true);
    setSelectedUser(item.userProfile);
    setLocalCommentList([]);
    var temp = [...comments];
    var tempList = temp.filter(
      (x) =>
        x.isAssignment === true &&
        x.stageId === currentStage &&
        x.userId === item.userProfile.id
    );
    setLocalCommentList([...tempList]);
  };

  const searchCommentsViewAll = () => {
    setIsFiltered(false);
    setSelectedUser(null);
    setLocalCommentList([]);
    setLocalCommentList([...comments]);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [activeShowMore, setActiveShowMore] = useState(false);
  const [pageSize, setPageSize] = useState(10000);
  const [onClickShowMore, setOnClickShowMore] = useState(false);

  useEffect(() => {
    if (onClickShowMore) {
      getForumDetails();
    }
  }, [onClickShowMore]);
  const getForumDetails = () => {
    var tempPageNumber = 1;
    if (onClickShowMore) {
      tempPageNumber = pageNumber;
    }
    NetworkAxios.get("Forum/getforumbyid/" + teamForumId + "/" + offeringUserId + "/" + tempPageNumber + "/" + pageSize)
      .then(function (response) {
        var temp = response.data;
        setThread(temp.forumTitle);

        var tempSelectedForumComments = JSON.parse(JSON.stringify(comments));
        if (onClickShowMore) {
          var totalComment = temp.comments.concat(tempSelectedForumComments);
          setLocalCommentList(totalComment);
          setcomments(totalComment);
          setOnClickShowMore(false);

          if (totalComment.length == pageSize * pageNumber) {
            setPageNumber(pageNumber + 1);
            setActiveShowMore(true);
          } else {
            setActiveShowMore(false);
          }
        } else {
          setLocalCommentList(temp.comments);
          setcomments(temp.comments);
          setOnClickShowMore(false);

          if (temp.comments.length == pageSize) {
            setPageNumber(2);
            setActiveShowMore(true);
          } else {
            setActiveShowMore(false);
          }
        }



        if (isFiltered) {
          setLocalCommentList([]);
          var temp = [...comments];
          var tempList = temp.filter(
            (x) =>
              x.isAssignment === true &&
              x.stageId === currentStage &&
              x.userId === selectedUser.id
          );
          setLocalCommentList([...tempList]);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getSubmittedAssignments = () => {
    NetworkAxios.get("Comment/getassignments/" + teamId + "/" + currentStage)
      .then(function (response) {
        var temp = response.data;
        var index = temp
          .map(function (e) {
            return e.userProfile.id;
          })
          .indexOf(userId);
        var userObj = temp[index];
        if (userObj) {
          if (userObj.totalAssignments > userObj.completedAssignments)
            setShowAssignment(true);
          else setShowAssignment(false);
        }
        else setShowAssignment(false);
        setAssignmentList([]);
        setAssignmentList(temp);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getForumDetails();
    //    / if (stageActivities.some(x => x.activityTypeId == 3))
    getSubmittedAssignments();
  }, []);

  const refreshData = () => {
    getForumDetails();
    if (stageActivities.some((x) => x.activityTypeId == 3))
      getSubmittedAssignments();
  };

  const setLikeItem = (islike, item) => {
    var temp = [...comments];
    if (
      item.parentCommentId == null ||
      item.parentCommentId == undefined ||
      item.parentCommentId == 0
    ) {
      var index = temp
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.id);
      temp[index]["isLiked"] = islike;
      if (islike) {
        temp[index]["likes"] = temp[index]["likes"] + 1;
      } else {
        temp[index]["likes"] = temp[index]["likes"] - 1;
      }
    } else {
      var parentIndex = temp
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.parentCommentId);
      var index = temp[parentIndex]["replies"]
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.id);
      temp[parentIndex]["replies"][index]["isLiked"] = islike;
      if (islike) {
        temp[parentIndex]["replies"]["likes"] =
          temp[parentIndex]["replies"]["likes"] + 1;
      } else {
        temp[parentIndex]["replies"]["likes"] =
          temp[parentIndex]["replies"]["likes"] - 1;
      }
    }
    setcomments([...temp]);
    setLocalCommentList([...temp]);
  };

  const openProfile = (userId) => {
    dispatch(authSlice.actions.setProfileData({ userId: userId }));
    dispatch(authSlice.actions.showProfile());
  };

  const AssignmentBox = (props) => {
    return (
      <div
        className={props.className}
        onClick={() => props.searchComment()}
        style={{ margin: "0 5px" }}
      >
        <div style={{ margin: 0 }} className="assignmentBox assignmentBoxRow">
          <div className="assignmentBoxRow">
            <Avatar {...props.userProfile} className="small" />

            <div
              style={{ padding: 0 }}
              onClick={() => {
                openProfile(props.userProfile.id);
              }}
            >
              <div className="assignment-username">
                {props.userProfile.firstName}
              </div>
              <div className="assignment-username">
                {props.userProfile.lastName}
              </div>
            </div>
          </div>

          <div>
            <span className="assignmentCompleted">
              ({props.completedAssignments}/{props.totalAssignments})
            </span>
            <div className="outer">
              <div
                className="inner"
                style={{
                  width: `${(props.completedAssignments / props.totalAssignments) * 100
                    }%`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {assignmentList &&
        assignmentList.length > 0 &&
        assignmentList[0].totalAssignments > 0 && (
          <Row>
            <Col className="next-step-title">
              <div className="px-3 py-4 content">
                <ContentHeading title="Submitted Assignments" />
              </div>
            </Col>
          </Row>
        )}
      <Row style={{ margin: 0, padding: "0 20px" }} className="solve">
        {assignmentList &&
          assignmentList.length > 0 &&
          assignmentList[0].totalAssignments > 0 && (
            <Slider {...settings}>
              {assignmentList.map((item, index) => {
                return (
                  <>
                    <AssignmentBox
                      className={`assignmentBoxSpace ${selectedUser && selectedUser.id == item.userProfile.id
                        ? "assignmentBoxHover"
                        : ""
                        }`}
                      key={index}
                      searchComment={() => {
                        searchComments(item);
                      }}
                      {...item}
                    />
                    {/* <Col className={`assignmentBoxSpace ${selectedUser && selectedUser.id == item.userProfile.id ? 'assignmentBoxHover' : ''}`} key={index} onClick={() => { searchComments(item) }}>
                                    <Row style={{ margin: "0 5px" }}>
                                        <Col style={{ padding: 0 }}>
                                            <Row style={{ margin: 0 }} className="assignmentBox assignmentBoxRow">
                                                <Col sm={8}>
                                                    <Row className="assignmentBoxRow">
                                                        <Col sm={6} style={{ padding: 0 }}>
                                                            <Avatar {...item.userProfile} className="small" />
                                                        </Col>
                                                        <Col sm={6} style={{ padding: 0 }} onClick={() => { openProfile(item.userProfile.id) }}>
                                                            <div className="assignment-username">{item.userProfile.firstName}</div>
                                                            <div className="assignment-username">{item.userProfile.lastName}</div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={4}>
                                                    <span className="assignmentCompleted">({item.completedAssignments}/{item.totalAssignments})</span>
                                                    <div className='outer'><div className='inner' style={{ width: `${(item.completedAssignments / item.totalAssignments) * 100}%` }}></div></div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col> */}
                  </>
                );
              })}
            </Slider>
          )}
      </Row>
      {selectedUser && (
        <Row className="searchResultText">
          <Col className="searchResultDiv">
            <span>
              Showing assignments for {selectedUser.firstName}{" "}
              {selectedUser.lastName}
            </span>
            <button
              style={{ cursor: "pointer" }}
              className=""
              onClick={() => {
                searchCommentsViewAll();
              }}
            >
              Clear
            </button>
          </Col>
        </Row>
      )}

      <div className="p-3 content">
        <div className="comment-seprator">
          <div className="background"></div>
          {/* <span className="title"><nobr>Comments</nobr></span> */}
        </div>
      </div>
      <div className="scroll-content content-padding pt-2">
        {!isFiltered && (
          <PostComment
            thread={thread}
            forumId={teamForumId}
            showAssignment={showAssignment}
            reloadComments={refreshData}
            setCommentText={props.setCommentText}
            commentText={props.commentText}
          />
        )}
        {localCommentList &&
          localCommentList
            .sort((a, b) => (a.commentedOn < b.commentedOn ? 1 : -1))
            .map((item, index) => {
              return (
                <Comment
                  thread={thread}
                  key={`comment${index}-${item.id}`}
                  forumId={teamForumId}
                  setLikeItem={setLikeItem}
                  reloadComments={getForumDetails}
                  comment={item}
                  showAssignment={showAssignment}
                />
              );
            })}
        {comments.length >= pageSize && activeShowMore && (
          <ShowMore onClick={() => { setOnClickShowMore(true); }} />
        )}
      </div>
    </>
  );
};

export default Solve;
